module.exports = __webpack_public_path__ + "img/38_BF16_peckish.2b822cf0.jpg";